import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <Link to="/">
          <Button variant="ghost" className="mb-8 gap-2">
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Button>
        </Link>

        <h1 className="text-4xl font-bold mb-8">Política de Privacidade</h1>
        
        <div className="prose prose-neutral max-w-none space-y-8 text-muted-foreground">
          <p className="text-lg">
            Última atualização: Janeiro de 2025
          </p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">1. Introdução</h2>
            <p>
              A Nutri IA está comprometida em proteger a privacidade dos seus usuários. Esta Política de Privacidade 
              explica como coletamos, usamos, divulgamos e protegemos suas informações quando você utiliza nossa plataforma.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">2. Informações que Coletamos</h2>
            <p>Podemos coletar as seguintes categorias de informações:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Informações de Conta:</strong> Nome, e-mail, telefone e dados profissionais.</li>
              <li><strong>Dados de Pacientes:</strong> Informações inseridas por você sobre seus pacientes para gestão de consultas e planos alimentares.</li>
              <li><strong>Dados de Uso:</strong> Informações sobre como você interage com nossa plataforma.</li>
              <li><strong>Informações Técnicas:</strong> Endereço IP, tipo de navegador, dispositivo e sistema operacional.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">3. Como Usamos Suas Informações</h2>
            <p>Utilizamos suas informações para:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fornecer e manter nossos serviços</li>
              <li>Personalizar sua experiência na plataforma</li>
              <li>Processar transações e enviar notificações relacionadas</li>
              <li>Melhorar nossos produtos e serviços</li>
              <li>Comunicar atualizações e informações relevantes</li>
              <li>Garantir a segurança e integridade da plataforma</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">4. Compartilhamento de Informações</h2>
            <p>
              Não vendemos suas informações pessoais. Podemos compartilhar dados apenas nas seguintes circunstâncias:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Com prestadores de serviços que nos auxiliam na operação da plataforma</li>
              <li>Para cumprir obrigações legais</li>
              <li>Com seu consentimento explícito</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">5. Segurança dos Dados</h2>
            <p>
              Implementamos medidas técnicas e organizacionais apropriadas para proteger suas informações contra 
              acesso não autorizado, alteração, divulgação ou destruição. Isso inclui criptografia de dados, 
              controles de acesso e monitoramento contínuo de segurança.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">6. Seus Direitos</h2>
            <p>Você tem o direito de:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Acessar suas informações pessoais</li>
              <li>Corrigir dados incorretos ou desatualizados</li>
              <li>Solicitar a exclusão de seus dados</li>
              <li>Retirar seu consentimento a qualquer momento</li>
              <li>Exportar seus dados em formato legível</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">7. Retenção de Dados</h2>
            <p>
              Mantemos suas informações pelo tempo necessário para fornecer nossos serviços ou conforme exigido 
              por lei. Quando os dados não forem mais necessários, serão excluídos de forma segura.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">8. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre quaisquer 
              alterações significativas por e-mail ou através de um aviso em nossa plataforma.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">9. Contato</h2>
            <p>
              Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco através do 
              e-mail: contato@nutri-ia.com.br
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <Link to="/">
            <Button variant="ghost" className="gap-2">
              <ArrowLeft className="w-4 h-4" />
              Voltar para a página inicial
            </Button>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;